<template>
  <div class="mb-4 space-y-2">
    <ETextArea id="comment" v-model="v$.comment.$model" name="comment" />
    <EButton
      :label="t(useTranslationPath(callerPath, 'buttonLabel'))"
      block
      @click="onAddComment"
    />
  </div>
</template>

<script setup>
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { EButton, ETextArea } from '@expansivefm/eds'
import useVuelidate from '@vuelidate/core'
import { minLength, required } from '@vuelidate/validators'
import { inject, reactive } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  workOrderId: {
    type: Number,
    required: true,
  },
})

const emits = defineEmits(['added'])

const $apiAuthenticatedRequest = inject('$apiAuthenticatedRequest')

const { t } = useI18n()
const callerPath = 'components.workOrder.updates.addComment'

const form = reactive({
  comment: null,
})

const validationRules = {
  comment: {
    required: required,
    minLength: minLength(2),
  },
}

const v$ = useVuelidate(validationRules, form)

const onAddComment = async () => {
  v$.value.$touch()

  if (v$.value.$invalid) {
    return
  }

  await $apiAuthenticatedRequest.post(
    'work-order-comments',
    $apiAuthenticatedRequest.configs.post.setData({
      workOrder: props.workOrderId,
      message: form.comment,
    }),
  )

  // emit added
  emits('added')
}
</script>
